import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/valentine.css";
import confetti from "canvas-confetti";

// Sounds
import openSoundFile from "../assets/sounds/universfield-magic-03-278824.mp3";
import yesSoundFile from "../assets/sounds/yes-level-up-3-189853.mp3";
import noSoundFile from "../assets/sounds/boing-101318.mp3";
import {Helmet} from "react-helmet";

function ValentineCard(props) {
    const { name = "" } = useParams();

    const [isOpen, setIsOpen] = useState(false);
    const [showButtons, setShowButtons] = useState(false);
    const [noPosition, setNoPosition] = useState({ x: 0, y: 0 }); // initial korrekt

    // Sounds
    const openSound = useRef(new Audio(openSoundFile));
    const yesSound = useRef(new Audio(yesSoundFile));
    const noSound = useRef(new Audio(noSoundFile));

    const playSound = (soundRef, volume = 0.7) => {
        const audio = soundRef.current;
        audio.currentTime = 0;
        audio.volume = volume;
        audio.play().catch(() => {});
    };

    // Card öffnen
    const handleCardClick = () => {
        setIsOpen(!isOpen);

        if (!isOpen) {
            playSound(openSound, 0.7);

            setTimeout(() => {
                heartConfetti();
                setShowButtons(true);
            }, 1500);
        } else {
            setShowButtons(false);
        }
    };

    // Confetti
    const heartConfetti = () => {
        confetti({
            particleCount: 120,
            spread: 90,
            origin: { y: 0.6 },
            colors: ["#ff4d6d", "#ff8fa3", "#ffb3c1", "#ffc2d1"],
        });
    };

    // JA Button
    const handleYes = () => {
        playSound(yesSound, 0.7);

        window.open(
            `https://wa.me/${props.whatsapp}?text=${encodeURIComponent(
                props.whatsappMessage
            )}`,
            "_blank"
        );
    };

    // NEIN Button → läuft weg nur beim Hover
    const handleNoClick = () => {
        playSound(noSound, 0.5);

        const x = Math.random() * 200 - 100;
        const y = Math.random() * 200 - 100;
        setNoPosition({ x, y });
    };

    // Optional: setze Startposition beim ersten Render
    useEffect(() => {
        setNoPosition({ x: 0, y: 0 }); // initial korrekt
    }, []);

    return (
        <div className="valentine-container">
            <Helmet>
                <title>{props.metatitle}</title>
                <meta name="description" content={props.metadescription} />

                <meta property="og:title" content={props.metatitle} />
                <meta property="og:description" content={props.metadescription} />
                <meta
                    name="theme-color"
                    content={props.themecolor}
                />
                <meta
                    name="theme-color"
                    content={props.themecolor}
                    media="(prefers-color-scheme: light)"
                />
                <meta
                    name="theme-color"
                    content={props.themecolor}
                    media="(prefers-color-scheme: dark)"
                />
            </Helmet>

            <div
                className={`valentine-card ${isOpen ? "open" : ""}`}
                onClick={handleCardClick}
            >
                {/* COVER */}
                <div className="valentine-card-cover">
                    <h2>Hey {name} ❤️</h2>
                    <h1>{props.coverTitle}</h1>
                    <p>{props.coverDescription}</p>
                </div>

                {/* CONTENT */}
                <div className={`valentine-card-content ${isOpen ? "active" : ""}`}>
                    <h2>{props.heading}</h2>

                    <p dangerouslySetInnerHTML={{ __html: props.message }} />

                    {showButtons && (
                        <div className="valentine-buttons">
                            <button
                                className="valentine-btn yes"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleYes();
                                }}
                            >
                                {props.yesText}
                            </button>

                            <button
                                className="valentine-btn no"
                                style={{
                                    transform: `translate(${noPosition.x}px, ${noPosition.y}px)`,
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNoClick();
                                }}
                            >
                                {props.noText}
                            </button>
                        </div>
                    )}

                    {showButtons && (
                        <p className="valentine-disclaimer">{props.disclaimer}</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ValentineCard;
